/**
 * @file       SSO client defaults for login start URL
 * @version    2.0.0
 * @author     Boris Veits
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or
 *             altered in anyway without expressed written permission from
 *             MindShare HDV LLC.
 */

// Empty: omit OIDC prompt so Microsoft can reuse browser SSO
const SSO_MANUAL_PROMPT = '';

const SSO_ERROR_REASON_CLIENT_SECRET_EXPIRED =
    'client_secret_expired';

const SSO_ERROR_MESSAGE_DEFAULT =
    'SSO sign in is unavailable. Please login manually.';

const SSO_ERROR_MESSAGE_CLIENT_SECRET_EXPIRED =
    'Azure SSO client secret has expired. ' +
    'Please renew it.';

/**
 * @desc   - map SSO redirect reason/code to a login error message
 * @access - public
 * @param  - string reason : optional reason from SSO redirect
 * @param  - string code : optional CyError code from SSO redirect
 * @return - string user-facing login error text
 */
function getSsoLoginErrorMessage
(
    reason: string,
    code: string
)
{
    let result;
    let normalizedReason;

    normalizedReason = String(reason || '').trim();
    result = SSO_ERROR_MESSAGE_DEFAULT;

    if (
        normalizedReason ===
            SSO_ERROR_REASON_CLIENT_SECRET_EXPIRED
    )
    {
        result = SSO_ERROR_MESSAGE_CLIENT_SECRET_EXPIRED;
    }
    else if (String(code || '').trim())
    {
        result = SSO_ERROR_MESSAGE_DEFAULT;
    }

    return result;
}

export
{
    SSO_MANUAL_PROMPT,
    SSO_ERROR_REASON_CLIENT_SECRET_EXPIRED,
    SSO_ERROR_MESSAGE_DEFAULT,
    SSO_ERROR_MESSAGE_CLIENT_SECRET_EXPIRED,
    getSsoLoginErrorMessage
};
